import { render, staticRenderFns } from "./Tabela.vue?vue&type=template&id=af12bed4&scoped=true"
import script from "./Tabela.vue?vue&type=script&lang=js"
export * from "./Tabela.vue?vue&type=script&lang=js"
import style0 from "./Tabela.vue?vue&type=style&index=0&id=af12bed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af12bed4",
  null
  
)

export default component.exports